import React from 'react';
import { Theme } from '@material-ui/core';
import { FeaturesConfigType } from '../utils/PortalUtils/portalConfigUtils';

interface PortalAssets {
  logo: {
    logoImageUrl: string;
    iconImageUrl: string;
    faviconUrl: string;
  };
  authImage: {
    signInUrl: string;
  };
  socialShareImage: {
    imageUrl: string;
  };
}

export interface AmplifyApiSettings {
  name: string;
  endpoint: string;
  region: string;
}

export interface PortalConfigMetadata {
  title: string;
  description: string;
  linkedInUrl: string;
  facebookUrl: string;
  instagramUrl: string;
  twitterUrl: string;
  gaMeasurementId?: string;
}

export interface PortalConfig {
  AWS: {
    Auth: {
      userPoolId: string;
    };
    API: {
      endpoints: AmplifyApiSettings[];
    };
    Cloudformation: {
      subdomain: string;
    };
  };
  features: FeaturesConfigType;
  MarketingSite: {
    Enabled: boolean;
    disableBadge: boolean;
    allowCallScheduling: boolean;
    callSchedulingLink: string;
  };
  name: string;
  metadata: PortalConfigMetadata;
  SignoutRedirectURL: string;
  assets: PortalAssets;
  theme: Theme;
  brand: {
    allowClientBranding: boolean;
  };
}

const defaultTheme = {
  palette: {
    primary: {
      main: '#000000',
      contrastText: '#fff',
    },
    secondary: {
      light: '#fff',
      main: '#fff',
      dark: '#ccc',
      contrastText: '#000',
    },
    error: {
      contrastText: '#fff',
      dark: '#b71c1c',
      main: '#e53935',
      light: '#ef5350',
    },
    text: {
      primary: '#263238',
      secondary: '#546e7a',
      link: '#1e88e5',
    },
    link: '#1565c0',
    icon: '#546e7a',
    background: {
      default: '#F4F6F8',
      paper: '#fff',
    },
    divider: '#eee',
  },
};

export const initialConfig: PortalConfig = {
  AWS: {
    Auth: {
      userPoolId: '',
    },
    API: {
      endpoints: [],
    },
    Cloudformation: {
      subdomain: '',
    },
  },
  features: {},
  name: '',
  metadata: {
    title: '',
    description: '',
    gaMeasurementId: '',
    facebookUrl: '',
    instagramUrl: '',
    linkedInUrl: '',
    twitterUrl: '',
  },
  MarketingSite: {
    Enabled: false,
    disableBadge: false,
    allowCallScheduling: false,
    callSchedulingLink: '',
  },
  SignoutRedirectURL: '',
  assets: {
    logo: {
      logoImageUrl: '',
      iconImageUrl: '',
      faviconUrl:
        'https://assets-global.website-files.com/60647db7cc60cf4759e292d5/60647db7cc60cfa735e29443_icon_white.png',
    },
    authImage: {
      signInUrl: '',
    },
    socialShareImage: {
      imageUrl: '',
    },
  },
  theme: defaultTheme,
  brand: {
    allowClientBranding: false,
  },
};

export const PortalConfigContext = React.createContext(initialConfig);
